import { Pipe, PipeTransform } from '@angular/core';
import { ProjectDataStatusList } from '../entities/project-data-status.list';
import { ModelService } from '../services/model.service';

@Pipe({
	name: 'projectStatusPipe',
	pure: false
})
export class ProjectStatusPipe implements PipeTransform {
	//private cachedData: any = null;
	//private cachedUrl = '';

	constructor(private modelService: ModelService) {}

	public transform(stateId: string): string {
		let currentStatus: any = ProjectDataStatusList.find((status) => {
			return status.value == stateId;
		});

		if (!currentStatus) {
			currentStatus = ProjectDataStatusList[1];
		}
		return this.modelService.getString(currentStatus.label);
	}

}
